import type { UseVariantOptions } from "./useVariant"
import { useVariant } from "./useVariant"

type UseIsFeatureEnabledOptions = Pick<UseVariantOptions<unknown>, "disableExposureEvent"> & {
  defaultValue?: string
  enabledValue?: string
}

export const useIsFeatureEnabled = (
  name: string,
  { defaultValue = "off", enabledValue = "on", disableExposureEvent = false }: UseIsFeatureEnabledOptions = {},
): boolean => {
  const variant = useVariant(name, { fallback: defaultValue, disableExposureEvent })

  return variant.value === enabledValue
}
